(ns shared.core.components.dragon-drop
  (:require [shared.core.reactive :as re]
            [shared.core.components.icon :as icon]
            [shared.core.style :as style]
            [shared.core.util :as util]
            ["react-beautiful-dnd" :as react-dnd]
            [shared.core.components.theme :as theme]))

(defn drop-message-box [{:keys [style message error? error-style error-message]}]
  [:div {:style (merge {:background-color (util/hex->rgba (style/color :green :base) 0.3)
                        :border (str "1px solid " (style/color :green :base))
                        :border-radius 3
                        :color (style/color :green :base)
                        :font-size 18
                        :font-weight style/font-medium-weight
                        :display :flex
                        :align-items :center
                        :justify-content :center
                        :padding 50
                        :width "100%"}
                       (when error?
                         {:background-color (util/hex->rgba (style/color :red :base) 0.3)
                          :border (str "1px solid " (style/color :red :base))
                          :color (style/color :red :base)})
                       (when error?
                         error-style)
                       style)}
   (if error?
     (or error-message "Error")
     (or message "Drop Here"))])

(defn dropzone [{:keys [dragging?*]} _]
  (let [dragging?* (or dragging?* (re/ratom false))]
    (fn [{:keys [id on-drop on-drag-over on-drag-leave style dragging-style file-types on-file-type-drop-error]}
         & contents]
      (into [:div {:id id
                   :on-drop #(do
                               (reset! dragging?* false)
                               (when-let [ft (some->> file-types (into #{}))]
                                 (try
                                   (if (some->> (.. % -dataTransfer -files)
                                                (some (fn [f]
                                                        (not (contains? ft (.-type f))))))
                                     (when on-file-type-drop-error
                                       (on-file-type-drop-error %))
                                     (when on-drop
                                       (on-drop %)))
                                   (catch :default _
                                     (when on-drop
                                       (on-drop %)))))
                               (.preventDefault %))
                   :on-drag-over #(do
                                    (reset! dragging?* true)
                                    (when on-drag-over
                                      (on-drag-over %))
                                    (.preventDefault %))
                   :on-drag-leave #(do
                                     (reset! dragging?* false)
                                     (when on-drag-leave
                                       (on-drag-leave %))
                                     (.preventDefault %))
                   :style (merge style
                                 (when @dragging?*
                                   dragging-style))}]
            contents))))

(defn dragon-drop-list [{:keys [droppable-id items on-drag-start on-drag-update on-drag-end droppable-style
                                droppable-dragging-style draggable-style draggable-dragging-style disabled?]}]
  (let [gray-border (str "1px solid " (style/color :gray :shade-7))]
    [:> react-dnd/DragDropContext {:on-drag-start on-drag-start
                                   :on-drag-update on-drag-update
                                   :on-drag-end (fn [resp]
                                                  (let [{:keys [source destination]} (util/->kebab-case-keywords
                                                                                       (js->clj resp))]
                                                    (on-drag-end
                                                      {:reordered-items (util/vec-move items
                                                                                       (:index source)
                                                                                       (:index destination))
                                                       :resp resp})))}
     [:> react-dnd/Droppable {:droppable-id (or droppable-id "droppable")}
      (fn [provided snapshot]
        (re/as-element
          (into [theme/theme
                 :div (merge {:ref (.-innerRef provided)
                              :style (merge {:border gray-border
                                             :border-radius 3}
                                            droppable-style
                                            (when (.-isDraggingOver snapshot)
                                              (merge {:background-color (style/color :gray :shade-7)}
                                                     droppable-dragging-style)))
                              :theme (style/dark-style {:background-color (when (.-isDraggingOver snapshot)
                                                                            (style/dark-color :surface :base))})}
                             (js->clj (.-droppableProps provided)))]
                (concat (map-indexed (fn [idx {:keys [id content]}]
                                       [:> react-dnd/Draggable {:draggable-id (str id)
                                                                :key (str id)
                                                                :index idx
                                                                :is-drag-disabled disabled?}
                                        (fn [provided snapshot]
                                          (let [draggable-props (js->clj (.-draggableProps provided))
                                                drag-handle-props (js->clj (.-dragHandleProps provided))]
                                            (re/as-element
                                              (into [theme/theme
                                                     :div
                                                     (merge {:ref (.-innerRef provided)}
                                                            draggable-props
                                                            drag-handle-props
                                                            {:style (merge {:background-color (style/color :white :base)
                                                                            :border-top (when (not= idx 0)
                                                                                          gray-border)
                                                                            :display :flex
                                                                            :align-items :center
                                                                            :padding "8px 9px 8px 4px"}
                                                                           draggable-style
                                                                           (get draggable-props "style")
                                                                           (when (.-isDragging snapshot)
                                                                             (merge {:border-top gray-border
                                                                                     :border-right gray-border
                                                                                     :border-bottom gray-border
                                                                                     :border-left gray-border
                                                                                     :opacity 0.8}
                                                                                    draggable-dragging-style)))
                                                             :theme (style/dark-style {:background-color (style/dark-color :surface :darker-1)})})]
                                                    (concat (when-not disabled?
                                                              [[icon/material-icon {:icon-type :drag_indicator
                                                                                    :style {:margin-right 5}}]])
                                                            [content])))))])
                                     items)
                        [(.-placeholder provided)]))))]]))
